import User from './User';

export default class UsersEvaluator {
  constructor(data) {
    this.id = data?.id;
    this.stage = data?.stage;

    this.evaluator = data?.evaluator ? new User(data?.evaluator) : null;
  }
}
